// extracted by mini-css-extract-plugin
export default {"component":"styles__component--uH3nw","picture":"styles__picture--u0Hyy","color":"styles__color--mzqD1"};